import PopOnChange from './PopOnChange';

const VARIANTS = {
  // The admin's yellow (the menu, the tabs).
  accent: 'bg-yellow-100 text-yellow-800',
  // White and framed like a kanban card, on a grey surface (a column's head).
  outline: 'border border-gray-200 bg-white text-gray-700',
  // Amber on its tint, as in the prototype's sidebar.
  soft: 'bg-amber-50 text-amber-700',
};

// A count beside a label (a tab, a menu entry, a column): it pops when it
// changes.
const CountBadge = ({ value, variant = 'accent' }) => (
  <span
    className={`flex h-5 min-w-[20px] shrink-0 items-center justify-center rounded px-1 text-xs font-medium ${VARIANTS[variant]}`}
  >
    <PopOnChange value={value} />
  </span>
);

export default CountBadge;
